export function shouldRenderProposedRichTextComparison(change = {}) {
    if (change.oldText !== "") return false
    if (typeof change.newText !== "string") return false

    return containsHtmlMarkup(change.newText)
}

function containsHtmlMarkup(value) {
    return /<\s*\/?\s*[a-z][^>]*>/i.test(`${value || ""}`)
}
